
import { mapActions } from "vuex";
import Form from "./Form.vue";

export default {
  name: "app-lista-preco-servico-update",
  components: {
    Form,
  },
  data() {
    return {
      lista: {},
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    async carregarLista() {
      this.setLoading(true);
      try {
        const { data } = await this.$http.post("/servicos/lista-preco/find", {
          id_lista_preco_servico: this.$route.params.id_lista_preco_servico,
        });
        this.lista = data;
      } catch (error) {
        this.$toast.error("Lista de preços de serviços não encontrada!");
        this.$router.push({ name: "listaPrecosServicos" });
      } finally {
        this.setLoading(false);
      }
    },
  },
  mounted() {
    this.carregarLista();
  },
};
